import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]

import { LocaleString } from '@/api-client/models/utilization/Contracts'
import * as d3 from 'd3'
import { computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  width: number
  height: number
  colors: { color: string; label?: LocaleString }[]
  kpi?: string
}

const fontSize = 10

export default /*@__PURE__*/_defineComponent({
  __name: 'ColorLegendCategorical',
  props: {
    width: {},
    height: {},
    colors: {},
    kpi: {}
  },
  setup(__props: any) {

const props = __props
const { t, locale } = useI18n()
const viewBox = computed(() => {
  return `0 0 ${props.width} ${props.height}`
})

const margins = {
  top: 0,
  right: 8,
  bottom: 0,
  left: 8
}
const containerHeight = computed(() => props.height - margins.top - margins.bottom)
const containerWidth = computed(() => props.width - margins.left - margins.right)
const radius = computed(() => 8)
const kpiComputed = computed(() => {
  if (props.kpi === 'TREND') {
    return [
      {
        label: 'general__text__down',
        color: '#FF4D4F',
        img: 'Icon-Trending-Down.svg'
      },
      {
        label: 'general__text__unchanged',
        color: '#40A9FF',
        img: 'Icon-Trending.svg'
      },
      {
        label: 'general__text__up',
        color: '#73D13D',
        img: 'Icon-Trending-Up.svg'
      }
    ]
  }
  return [] // or any other default value
})
onMounted(() => {
  setupComponent()
  updateColors()
})

watch(
  () => props.width,
  () => updateColors()
)
watch(
  () => props.kpi,
  () => updateColors()
)

watch(locale, () => updateColors())

function updateColors(): void {
  let svg = d3.select('svg.legend')
  const container = svg.select('.container')
  container.selectChildren().remove()
  container.selectAll('circle').remove()
  generateCircles(container)
}

function generateCircles(container) {
  const count = props.colors.length
  const width = (containerWidth.value - radius.value * 2) / (count - 1)
  if (props.kpi === 'TREND') {
    kpiComputed.value.forEach((trend, i) => {
      const title = t(trend.label)
      const x = radius.value + i * width
      container
        .append('circle')
        .attr('class', 'circle')
        .attr('cx', `${x}px`)
        .attr('cy', `${radius.value}px`)
        .attr('fill', trend.color)
        .attr('r', radius.value)
      container
        .append('text')
        .attr('class', 'text')
        .attr('x', `${x}px`)
        .attr('y', `${containerHeight.value - 3}px`)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'Inter')
        .attr('font-style', 'normal')
        .attr('alignment-baseline', 'baseline')
        .attr('line-height', '12px')
        .attr('font-weight', '400')
        .attr('font-size', `${fontSize}px`)
        .text(title)
    })
  } else {
    props.colors.forEach((color, i) => {
      const x = radius.value + i * width
      container
        .append('circle')
        .attr('class', 'circle')
        .attr('cx', `${x}px`)
        .attr('cy', `${radius.value}px`)
        .attr('fill', color.color)
        .attr('r', radius.value)
      container
        .append('text')
        .attr('class', 'text')
        .attr('x', `${x}px`)
        .attr('y', `${containerHeight.value - 3}px`)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'Inter')
        .attr('font-style', 'normal')
        .attr('alignment-baseline', 'baseline')
        .attr('line-height', '12px')
        .attr('font-weight', '400')
        .attr('font-size', `${fontSize}px`)
        .text(color.label?.[locale.value])
    })
  }
}

function setupComponent(): void {
  // Select svg
  let svg = d3.select('svg.legend')
  // Add container group
  const container = svg
    .append('g')
    .attr('class', 'container')
    .attr('width', containerWidth.value)
    .attr('height', containerHeight.value)
    .attr('transform', `translate(${margins.left}, ${margins.top})`)

  generateCircles(container)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "legend",
    style: _normalizeStyle({ height: `${_ctx.height}px` }),
    viewBox: viewBox.value
  }, null, 12, _hoisted_1))
}
}

})